<div>
  <div class="p-3 d-flex flex-column h-100">
    <div class="mb-3 d-flex justify-content-between align-items-center">
      <h5 class="mb-0">
        Projects
        <i class="ri-information-fill align-bottom text-info" [ngbTooltip]="projectsTips" placement="auto"></i>
      </h5>
      <i class="ri-close-line d-lg-none pointer" style="font-size: 1.5em;" (click)="closeSideBar()"></i>
    </div>
    <div class="search-box">
      <input type="text" class="form-control bg-light border-light" placeholder="Search here...">
      <i class="ri-search-2-line search-icon"></i>
    </div>
    <ngx-simplebar class="mt-3 mx-n4 mb-2 px-4 file-menu-sidebar-scroll">
      <ul class="list-unstyled file-manager-menu">
        @for (item of projects; track item; let i = $index) {
          <app-project-list-item [item]="item" [toCollapsed]="i"></app-project-list-item>
        }
      </ul>
    </ngx-simplebar>
  </div>
  <div class="mb-auto card bg-light overflow-hidden shadow-none">
    <div class="card-body">
      <div class="d-flex">
        <div class="flex-grow-1">
          <h6 class="mb-0">Plan Usage</h6>
        </div>
        <div class="flex-shrink-0">
          <h6 class="mb-0"><b class="text-success">{{ plan_usage.toFixed(1) }}%</b></h6>
        </div>
      </div>
    </div>
    <div class="progress bg-success-subtle rounded-0">
      <div class="progress-bar" [ngClass]="plan_usage < 50 ? 'bg-success' : plan_usage < 75 ? 'bg-warning' : 'bg-danger'" role="progressbar" [style.width.%]="plan_usage" [attr.aria-valuenow]="plan_usage" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
  </div>
</div>

<ng-template #projectsTips>
  <div class="d-flex flex-column">
    <span>Projects are like containers that host other projects, questionnaires, and open conversations.</span>
    <span>Each project can have sub-projects and its assigned roles and candidates.</span>
    <span>It is recommended to design projects view that reflects your organization for efficient management and navigation.</span>
  </div>
</ng-template>